import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';

import { SharedModule } from './shared/shared.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Our Stuff (Providers)
import { CartService } from './cart/cart.service';
import { NotificationsService } from './core/notifications/notifications.service';
import { GlobalErrorHandler } from './core/handlers/global-error.handler';

import { BsDropdownModule } from 'ngx-bootstrap';
import { SwiperModule } from 'angular2-useful-swiper';
import { StaticModule } from '../app/static/static.module';
import { MessageService } from 'primeng/components/common/messageservice';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    BsDropdownModule.forRoot(),
    ToastrModule.forRoot(),
    SwiperModule,
    StaticModule
  ],
  exports: [
    SharedModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    CartService,
    NotificationsService,
    MessageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts